import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuth } from "services/common/rtkQueryConfig";

export interface NotificationResponse {
  id: string;
  userId: string;
  nhDealApplicationId: string;
  title: string;
  text: string;
  link: string;
  createdOn: Date;
  notificationType?: NotificationType;
  isEsignViewed?: boolean;
}
export interface Consent {
  userId: string;
  nhDealApplicationId: string;
  prospectId?: string;
  consentTypes: ConsentTypes[];
}
export enum ConsentTypes {
  Econsent = "Econsent",
  PrivacyPolicy = "PrivacyPolicy",
  CreditConsent = "CreditConsent",
  DataSharing = "DataSharing",
  PhoneConsent = "PhoneConsent",
  TermsOfUse = "TermsOfUse",
  EmailConsent = "EmailConsent",
}
export enum NotificationType {
  Esign = "Esign",
}

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryWithAuth, //baseQuery
  endpoints: (build) => ({
    getNotificationDetails: build.query<NotificationResponse[], string>({
      query: (userId: string) => ({
        url: `/notification/user/${userId}`,
        method: "GET",
      }),
      keepUnusedDataFor: 0,
    }),
    setStatusFlagOfNotification: build.mutation<void, string>({
      query: (id: string) => ({
        url: `/notification/${id}/isViewed-flag`,
        method: "PATCH",
      }),
    }),
    setEsignStatusFlagOfNotification: build.mutation<void, string>({
      query: (id: string) => ({
        url: `/notification/${id}/esign-is-viewed-flag`,
        method: "PATCH",
      }),
    }),
    setConsent: build.mutation<void, { id: string; consent: Consent }>({
      query: ({ id, consent }) => ({
        url: `/compliance/nh-deal-application-id/${id}/consent`,
        method: "POST",
        body: consent,
      }),
    }),
  }),
});

export const {
  useGetNotificationDetailsQuery,
  useSetStatusFlagOfNotificationMutation,
  useSetEsignStatusFlagOfNotificationMutation,
  useSetConsentMutation,
} = userApi;
